import useAsyncData from "../../../hooks/use-async-data";
import plannerDriverPlanService from "../planner-driver-plan.service";
import PlannerDriverPlanList from "./planner-driver-plan-list";
import PlannerDriverPlanListParams from "./planner-driver-plan-list-params";

const usePlannerDriverPlanList = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<PlannerDriverPlanList>({
      data: [],
      totalCount: 0,
    });

  const load = async (
    params: PlannerDriverPlanListParams,
    signal: AbortSignal,
  ) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const plannerDriverPlanListData = await plannerDriverPlanService.getData(
        params,
        signal,
      );

      setData(plannerDriverPlanListData);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default usePlannerDriverPlanList;
